import React from "react";

const Home = () => (
  <div>
    <h1 className="title is-1" style={{color: 'black'}}>Home</h1>
    <p style={{color: 'black'}}>
      Hello, my name is Liam B. Twomey, welcome to my site. I am a ReactJS Student that lives in the Greater Toronto Area. Please use the navigation above to view the portfolio of sites I have made, the tools I use  and my contact information. If you are interested in working on any projects together, shoot me an email!
      <br></br>
      Thank you.  
    
    </p>
    <br></br>
    <br></br>
    <br></br>
  </div>
);

export default Home;